<template>
    <div id="errorReports">
        <AppBreadCrumb :paths="[{ title: $t('message.feedback') }]" :select="true"></AppBreadCrumb>
        <b-container fluid>
            <b-row>
                <b-col>
                    <a-table :columns="cols" :dataSource="errorReports" class="custom-table2">
                        <div slot="messageSlot" slot-scope="report" :key="report.message">
                            <div>
                                {{
                                    report.message.length > 150
                                        ? report.message.substring(0, 50) + "..."
                                        : report.message
                                }}
                            </div>
                            <div v-if="report.message.length > 150"></div>
                        </div>
                        <div slot="dateSlot" slot-scope="report" :key="report.date">
                            <div>
                                {{ report.date | date }}
                            </div>
                        </div>
                        <div slot="imageUrlSlot" slot-scope="report">
                            <div class="d-flex justify-content-center align-items-center">
                                <viewer
                                    :id="report.imageUrl"
                                    :images="[report.imageUrl]"
                                    @inited="(viewer) => inited(viewer, report)"
                                >
                                    <img
                                        v-show="false"
                                        :id="report.imageUrl"
                                        :src="report.imageUrl"
                                        class="img-thumbnail ant-upload-list-picture-card-container"
                                        style="object-fit: cover"
                                    />
                                </viewer>
                                <a-button class="actionButton d-flex align-items-center" @click="show(report._id)">
                                    <md-icon style="color: #c9f7f5">image</md-icon>
                                </a-button>
                            </div>
                        </div>
                        <div style="text-align: center" slot="replied" slot-scope="report" :key="report._id">
                            <input
                                v-model="report.replied"
                                type="checkbox"
                                class="chckbx dealt-with"
                                @change="CheckBoxChanged(report, 'replied')"
                            />
                        </div>
                        <div style="text-align: center" slot="solved" slot-scope="report" :key="report._id">
                            <input
                                v-model="report.solved"
                                type="checkbox"
                                class="chckbx solved"
                                @change="CheckBoxChanged(report, 'solved')"
                            />
                        </div>
                    </a-table>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import AppBreadCrumb from "../../components/common/AppBreadCrumb";

import { getErrorReports, updateErrorReports } from "../../api/errorReport";
import ActionEdit from "../../components/svg/ActionEdit";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import _ from "lodash";

Vue.use(Viewer);

// Mock data: test etmek için async getErrorReports() içerisinde ataması yorum satırı olarak duruyor.
const mockData = [
    {
        siteAlias: "supsis",
        reporterType: "representative",
        message: "Actually This is a mock bug",
        date: Date.now(),
        imageUrl: "https://placeimg.com/640/480/nature",
        replied: true,
        solved: true,
    },
    {
        siteAlias: "supsis",
        reporterType: "representative",
        message: "Actually This is a mock bug",
        date: Date.now(),
        imageUrl: "https://placeimg.com/640/480/nature",
        replied: false,
        solved: true,
    },
    {
        siteAlias: "supsis",
        reporterType: "representative",
        message: "Actually This is a mock bug",
        date: Date.now(),
        imageUrl: "https://placeimg.com/640/480/nature",
        replied: false,
        solved: true,
    },
    {
        siteAlias: "supsis",
        reporterType: "representative",
        message: "Actually This is a mock bug",
        date: Date.now(),
        imageUrl: "https://placeimg.com/640/480/nature",
        replied: false,
        solved: true,
    },
];

export default {
    name: "errorReports",
    components: {
        AppBreadCrumb,
        ActionEdit,
    },
    data() {
        return {
            errorReports: [],
            cols: [
                {
                    dataIndex: "siteAlias",
                    key: Math.floor(100000 + Math.random() * 900000),
                    title: this.$t("message.siteAlias"),
                },
                {
                    dataIndex: "reporterType",
                    key: Math.floor(100000 + Math.random() * 900000),
                    title: this.$t("message.type"),
                },
                {
                    scopedSlots: { customRender: "messageSlot" },
                    title: this.$t("message.message"),
                    width: "50%",
                },
                {
                    scopedSlots: { customRender: "dateSlot" },
                    title: this.$t("message.date"),
                },
                {
                    scopedSlots: { customRender: "imageUrlSlot" },
                    title: this.$t("message.imageUrl"),
                },
                {
                    scopedSlots: { customRender: "replied" },
                    title: this.$t("message.replied"),
                },
                {
                    scopedSlots: { customRender: "solved" },
                    title: this.$t("message.solved"),
                },
            ],
            visible: false,
            viewers: {},
        };
    },
    computed: {
        ...mapState({
            loggedUser: (state) => state.auth.adminUser,
            adminUser: (state) => state.auth.adminUser,
            bugExist: (state) => state.auth.bugExist || false,
        }),
    },
    methods: {
        ...mapActions({
            setBugExist: "auth/setBugExist",
        }),
        async getErrorReports() {
            getErrorReports()
                .then((response) => {
                    this.errorReports = _.orderBy(
                        response.data.errors.map((x) => ({
                            ...x,
                            ts: moment(x.createdAt).valueOf(),
                        })),
                        "ts",
                        "desc"
                    );
                })
                .catch((x) => {
                    console.error("get error failed", { x });
                });
            //data yoksa test etmek için açılabilir.
            setTimeout(() => {
                if (this.errorReports.length === 0) {
                    this.errorReports = mockData;
                }
            }, 3000);
        },
        inited(viewer, report) {
            this.viewers[report._id] = viewer;
        },
        show(id) {
            if (this.viewers[id]) this.viewers[id].show();
        },
        onChange(e) {},
        CheckBoxChanged(report, value) {
            updateErrorReports(report._id, value, report[value])
                .then(() => {
                    if (value === "solved") {
                        this.getErrorReports();
                        if (this.errorReports.some((element) => !element.value !== false)) {
                            this.setBugExist(true);
                        } else {
                            this.setBugExist(false);
                        }
                    }
                })
                .catch((e) => {
                    console.error("update error failed", e);
                });
        },
    },
    mounted() {
        this.getErrorReports();
    },
    beforeMount() {
        const isAccessEnabled =
            this.loggedUser.isFullAccess || this.loggedUser.approvedPages.some((page) => page.page === "error-reports");
        if (!isAccessEnabled) {
            this.$router.push("/denied");
        }
    },
    watch: {
        errorReports(newVal) {
            if (newVal.length === 0) {
                this.setBugExist(false);
            } else {
                if (newVal.some((element) => !element.solved !== false)) {
                    this.setBugExist(true);
                } else {
                    this.setBugExist(false);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.chckbx {
    margin: 8px;
    font-size: 20px;
}
</style>
